import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import List from './List';

function History() {
  return (
    <section>
      <FuelTypography tag="h3" size="heading-md" weight="bold" spacingTop={48}>
        Histórico da viagem
      </FuelTypography>
      <List />
    </section>
  );
}

export default History;
